module.exports = __webpack_public_path__ + "static/media/globalcom.c0d604a9.jpeg";